import React from 'react';

export const ParticipantsIcon: React.FC = () => (
  <svg width='11' height='15' viewBox='0 0 11 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0 12.5534C0 10.0006 2.06944 7.93115 4.62222 7.93115H5.77778C8.33056 7.93115 10.4 10.0006 10.4 12.5534C10.4 13.8298 9.36528 14.8645 8.08889 14.8645H2.31111C1.03472 14.8645 0 13.8298 0 12.5534Z'
      fill='var(--primary-accent)'
    />
    <circle cx='5.20008' cy='4.1178' r='3.12' fill='var(--primary-accent)' />
  </svg>
);
